import { Badge } from '@/components/ui/badge';

interface TaskStatusBadgeProps {
  status: string | undefined;
}

const statusConfig: Record<
  string,
  {
    label: string;
    variant: 'default' | 'secondary' | 'outline' | 'destructive';
    className?: string;
  }
> = {
  available: { label: 'Available', variant: 'default' },
  accepted: {
    label: 'In Progress',
    variant: 'secondary',
    className: 'bg-yellow-100 text-yellow-800 hover:bg-yellow-100/80',
  },
  // 'completed' means finished-but-unclaimed — rewards are distributed by the
  // player's explicit 'awarded' transition (the claim), so surface the action.
  completed: {
    label: 'Ready to Claim',
    variant: 'secondary',
    className: 'bg-green-100 text-green-800 hover:bg-green-100/80',
  },
  pending: {
    label: 'Pending',
    variant: 'secondary',
    className: 'bg-orange-100 text-orange-800 hover:bg-orange-100/80',
  },
  awarded: {
    label: 'Awarded',
    variant: 'secondary',
    className: 'bg-purple-100 text-purple-800 hover:bg-purple-100/80',
  },
  unavailable: { label: 'Unavailable', variant: 'outline' },
  waiting: { label: 'Waiting', variant: 'outline' },
  expired: { label: 'Expired', variant: 'outline' },
};

const fallbackConfig: { label: string; variant: 'default'; className?: string } = {
  label: 'Available',
  variant: 'default',
};

export function TaskStatusBadge({ status }: TaskStatusBadgeProps) {
  const config = (status && statusConfig[status]) || fallbackConfig;
  return (
    <Badge variant={config.variant} className={`text-xs shrink-0 ${config.className || ''}`}>
      {config.label}
    </Badge>
  );
}
